import { BodySubtext } from '@/components/atomic/text'
import { cn } from '@/utils/shadcn/utils'

export const BondSwapContainer: React.FC<
  React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>
> = ({ className, children, ...props }) => {
  return (
    <div className={cn('flex flex-col h-full', className)} {...props}>
      {children}
    </div>
  )
}

export const TopBondTableContainer: React.FC<
  React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>
> = ({ className, children, ...props }) => {
  return (
    <div className={cn('flex flex-col h-[120px] mt-4', className)} {...props}>
      {children}
    </div>
  )
}

export const BondTableWrapper: React.FC<
  React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>
> = ({ className, children, ...props }) => {
  return (
    <div
      className={cn(
        'h-full border border-primary-border rounded-lg p-1',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
}

export const AlternativeBondsContainer: React.FC<
  React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>
> = ({ className, children, ...props }) => {
  return (
    <div
      className={cn('flex flex-col flex-grow space-y-2', className)}
      {...props}
    >
      {children}
    </div>
  )
}

export const AlternativeBondsTableWrapper: React.FC<
  React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>
> = ({ className, children, ...props }) => {
  return (
    <div
      className={cn(
        'flex-grow h-full min-h-0 border border-primary-border rounded-lg p-1',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
}

export const DialogActionButtons: React.FC<
  React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>
> = ({ className, children, ...props }) => {
  return (
    <div className={cn('flex justify-end gap-2', className)} {...props}>
      {children}
    </div>
  )
}

export const DialogContentContainer: React.FC<
  React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>
> = ({ className, children, ...props }) => {
  return (
    <div className={cn('p-4 h-full flex flex-col', className)} {...props}>
      {children}
    </div>
  )
}

export const DialogPreviewContainer: React.FC<
  React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>
> = ({ className, children, ...props }) => {
  return (
    <div className={cn('h-full overflow-hidden', className)} {...props}>
      {children}
    </div>
  )
}

export const DialogPreviewBorder: React.FC<
  React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>
> = ({ className, children, ...props }) => {
  return (
    <div
      className={cn('h-full border-l border-primary-border', className)}
      {...props}
    >
      {children}
    </div>
  )
}

export const EmptyState: React.FC<{ text: string }> = ({ text }) => {
  return (
    <div className="bg-secondary-background rounded-lg h-full w-full flex items-center justify-center text-center px-4">
      <BodySubtext color="text-secondary">{text}</BodySubtext>
    </div>
  )
}
